export const currencySettingsData = [
  {
    id: "1",
    name: "Euro",
    code: "EUR",
    symbol: "€",
    exchangeRate: "Default",
    createdOn: "12 Jul 2023",
  },
  {
    id: "2",
    name: "England Pound",
    code: "GBP",
    symbol: "£",
    exchangeRate: "Default",
    createdOn: "14 Jul 2023",
  },
  {
    id: "3",
    name: "India Rupee",
    code: "INR",
    symbol: "₹",
    exchangeRate: "76.154",
    createdOn: "14 Mar 2023",
  },
  {
    id: "4",
    name: "US Dollar",
    code: "USD",
    symbol: "$",
    exchangeRate: "Default",
    createdOn: "10 Jan 2023",
  },
];
